import React, { useState } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { emailSignUpAction } from '../../redux/actions/authAction';
import successToast from '../../components/toast/successToast';
import errorToast from '../../components/toast/errorToast';
import logo from '../../assets/images/acumenVelocityLogo.svg';
import { Image } from 'react-bootstrap';
import { passwordSchema } from '../../utils/passwordValidation';
import PasswordStrengthMeter from '../../components/PasswordStrengthMeter';


/**Sign-up Module */
const Signup = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const initialValues = {
        email: '',
        password: '',
        invite_code: '',
        confirm_password: ''
    }
    const validationSchema = Yup.object().shape({
        email: Yup.string()
            .required("Required"),
        invite_code: Yup.string()
            .required("Required"),
        password: passwordSchema,
        confirm_password: Yup.string()
            .required("Required")
            .oneOf([Yup.ref("password"), null], "Passwords must match")
    });

    const onSuccess = (data) => {
        successToast(data.data.message);
        navigate('/email-login')
    }
    const onError = (data) => {
        errorToast(data.data.message);
    }


    const toggleShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const toggleShowConfirmPassword = () => {
        setShowConfirmPassword(!showConfirmPassword);
    };


    const onSubmit = (values) => {
        dispatch(emailSignUpAction(values, onSuccess, onError))
    }
    return (
        <div className='w-100 d-flex flex-column align-items-center gap-4' style={{ height: '100vh', backgroundColor: '#e9eef7' }}>
            <div className='d-flex gap-2 justify-content-start align-items-center cursor_pointer w-100' style={{ height: '4rem' }} onClick={() => navigate('/')}>
                <Image alt='logo' src={logo} height={40} className='mx-1' />
                <p className='name fs_16 fw_700'>Acumen Translation Hub</p>
            </div>
            <div className="d-flex justify-content-center align-items-center" style={{ height: '80vh' }}>
                <div className="card p-4 bg-white" style={{ width: '100%', maxWidth: '450px' }}>
                    <h5 className="card-title text-center mb-4">Sign Up</h5>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        onSubmit={onSubmit}
                    >
                        {({ values }) => (
                        <Form>
                            <div className="text-start gap-3 mb-2 text-nowrap mx-4">
                                <label htmlFor="email" className="py-1">Email</label>
                                <div className="d-flex position-relative">
                                    <Field
                                        type="email"
                                        placeholder="Enter your email"
                                        id="email"
                                        name="email"
                                        className="input-field"
                                        style={{ width: '100%' }}
                                    />
                                </div>
                                <ErrorMessage name="email" component="div" className="text-danger mt-1 fs_12" />
                            </div>

                            <div className="text-start gap-3 mb-2 text-nowrap mx-4">
                                <label htmlFor="invite_code" className="py-1">Invite code</label>
                                <div className="d-flex position-relative">
                                    <Field
                                        type="invite_code"
                                        placeholder="Enter your invite code"
                                        id="invite_code"
                                        name="invite_code"
                                        className="input-field"
                                        style={{ width: '100%' }}
                                    />
                                </div>
                                <ErrorMessage name="invite_code" component="div" className="text-danger mt-1 fs_12" />
                            </div>

                            <div className="text-start gap-3 mb-2 text-nowrap mx-4">
                                <label htmlFor="password" className="py-1">Password</label>
                                <div className="d-flex position-relative">
                                    <Field
                                        type={showPassword ? 'text' : 'password'}
                                        placeholder="Enter your Password"
                                        id="password"
                                        name="password"
                                        className="input-field"
                                        style={{ width: '100%' }}
                                    />
                                    <span
                                        onClick={toggleShowPassword}
                                        className="position-absolute end-0 top-0 mt-2 me-2 text-secondary fs_14"
                                        style={{ cursor: 'pointer' }}
                                    >
                                        {showPassword ? 'Hide' : 'Show'}
                                    </span>
                                </div>
                                <PasswordStrengthMeter password={values.password} />
                                <ErrorMessage name="password" component="div" className="text-danger mt-1 fs_12" />
                            </div>

                            <div className="text-start gap-3 mb-2 text-nowrap mx-4">
                                <label htmlFor="confirm_password" className="py-1">Confirm Password</label>
                                <div className="d-flex position-relative">
                                    <Field
                                        type={showConfirmPassword ? 'text' : 'password'}
                                        placeholder="Enter Confirm Password"
                                        id="confirm_password"
                                        name="confirm_password"
                                        className="input-field"
                                        style={{ width: '100%' }}
                                    />
                                    <span
                                        onClick={toggleShowConfirmPassword}
                                        className="position-absolute end-0 top-0 mt-2 me-2 text-secondary fs_14"
                                        style={{ cursor: 'pointer' }}
                                    >
                                        {showConfirmPassword ? 'Hide' : 'Show'}
                                    </span>
                                </div>
                                <ErrorMessage name="confirm_password" component="div" className="text-danger mt-1 fs_12" />
                            </div>
<div className='mt-1 d-flex justify-content-between gap-5'>
                                <button type="submit" className="btn btn-primary w-100 mx-4">Sign Up</button>
                                <button type="button" className="btn btn-primary w-100 mx-4" onClick={() => navigate('/')}>Cancel</button>
                            </div>
                        </Form>
                        )}
                    </Formik>
                </div>
            </div>
        </div>

    );
};
export default Signup;